// extracted by mini-css-extract-plugin
export default {"functionTitle":"Comment_functionTitle__Uq8OV","layout":"Comment_layout__SAvRh","errorMessage":"Comment_errorMessage__oVX-s"};